module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "拼团详情",
      "backFn": "true"
    },
    on: {
      "back": _vm.back
    }
  }), _vm._v(" "), (_vm.data) ? _c('header', [(_vm.data.groupbuyEx == 0 && _vm.data.isFullGroup == 1) ? _c('span', [_vm._v("拼团成功等待卖家发货")]) : _vm._e(), _vm._v(" "), (_vm.data.groupbuyEx == 0 && _vm.data.isFullGroup == 0) ? _c('div', [_c('span', [_vm._v("还差" + _vm._s(_vm.data.groupCount) + "人就可以满团了")]), _vm._v(" "), _c('p', [_vm._v("点击右上角 选择分享按钮 邀请你的好友一起来参团吧")])]) : _vm._e(), _vm._v(" "), (_vm.data.groupbuyEx == 1) ? _c('div', [_c('span', [_vm._v("拼团失败 已超时")]), _vm._v(" "), _c('p', [_vm._v("支付款将退回到支付账号请注意查收")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "commodity-info"
  }, [_c('div', {
    staticClass: "flex comm-t vux-1px-b"
  }, [_c('div', {
    staticClass: "img vux-1px"
  }, [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": _vm.data.groupbuyInfo.shop_info.shop_logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.groupbuyInfo.shop_info.shop_name))])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex vux-1px-b comm-content",
    attrs: {
      "tag": "div",
      "to": {
        name: 'detail',
        params: {
          id: _vm.data.groupbuyInfo.item_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": _vm.data.groupbuyInfo.groupbuy_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text flex-1 text-l"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.data.groupbuyInfo.groupbuy_title))]), _vm._v(" "), _c('div', {
    staticClass: "text-r public-gray"
  }, [_vm._v("x1")]), _vm._v(" "), _c('div', {
    staticClass: "flex comm-c-btm"
  }, [_c('div', [_c('span', {
    staticClass: "price public-red"
  }, [_vm._v("￥1.0")]), _vm._v(" "), _c('del', {
    staticClass: "public-gray"
  }, [_vm._v("2.00")])]), _vm._v(" "), _c('div', {
    staticClass: "public-gray"
  }, [_vm._v("\n                        2人拼团\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex btn"
  }, [_c('router-link', {
    staticClass: " vux-1px",
    attrs: {
      "tag": "span",
      "to": {
        name: 'spellGroupOrderDetail',
        params: {
          tid: _vm.data.localUserInfo.tid
        }
      }
    }
  }, [_vm._v("查看订单详情")]), _vm._v(" "), _c('router-link', {
    staticClass: " vux-1px",
    attrs: {
      "tag": "span",
      "to": {
        name: 'courierInfo',
        params: {
          tid: _vm.data.localUserInfo.tid
        }
      }
    }
  }, [_vm._v("查看物流")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "join-person"
  }, [_c('div', {
    staticClass: "join-top vux-1px-b"
  }, [_c('span', {
    staticClass: "first"
  }, [_vm._v("团长")]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": _vm.data.usersInfo[0].headimgurl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.usersInfo[0].name))])]), _vm._v(" "), _vm._l((_vm.data.usersInfo), function(item) {
    return _c('div', {
      staticClass: "list flex vux-1px-b"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.headimgurl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-1 text-l"
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "public-gray"
    }, [_vm._v(_vm._s(_vm._f("timerForm")(item.create_time)) + "参与")])])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a4db319"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/spellGroup/Detail/Detail.vue
// module id = 547
// module chunks = 0